/**
 * As permissões da base de conhecimento, do lado da tela.
 *
 * ## Por que num módulo próprio
 *
 * A mesma permissão é lida na página de vídeos E na central de ajuda -- as
 * duas fixam material. Repetir a string nos dois arquivos é como ela
 * diverge: alguém corrige um `#fixar-material` num lugar e o outro continua
 * perguntando pelo nome antigo, negando em silêncio.
 *
 * ## A string é a MESMA do servidor
 *
 * `PermissionService::PERMISSION_PIN_KNOWLEDGE_MATERIAL`. Quem GARANTE é a
 * api; o que a tela faz com isto é não oferecer um botão que responderia 403.
 * Os dois lados precisam concordar no texto, e é por isso que o teste afirma o
 * valor literal em vez de só importá-lo.
 */

/**
 * Fixar material no topo da base (Gisele, 23/10/2026).
 *
 * "Criar uma configuração para definir quem poderá fixar os vídeos: operador
 * ou somente administrador."
 *
 * Virou permissão, e não uma chave de configuração: permissão já tem tela, já
 * é por perfil e já é auditável. Uma chave nova seria um segundo lugar onde se
 * decide quem pode o quê -- e os dois divergiriam.
 */
export const PERMISSAO_FIXAR = '#fixar-material-da-base';

/**
 * Editar o material da base -- título, descrição, categoria, tags, conteúdo.
 *
 * "Perfil Líder: editar vídeos" e "Perfil Operador: não permitir editar
 * descrições/conteúdos" (Gisele).
 *
 * Era `hasAdminProfile` cravado na tela. Virou permissão por decisão do dono
 * do produto em 03/11/2026, e pela mesma razão da de fixar: a tela de
 * permissões já decide isto por perfil, e trocar o papel no código criaria um
 * segundo lugar onde se decide quem pode o quê.
 *
 * **Não** cobre excluir: "Perfil Administrador: controle completo". Apagar
 * tira o material da base e do índice do Orby, e não tem desfazer.
 */
export const PERMISSAO_EDITAR = '#editar-material-da-base';

/**
 * A página de Vídeos e Manuais, separada da de IA / Base de Conhecimento.
 *
 * As duas eram a MESMA permissão, e a barra lateral mostrava os dois links sob
 * ela. "Perfil Operador: não apresentar a opção de IA/Base de Conhecimento" e
 * "disponibilizar somente Vídeos e Treinamentos" só é configurável com as duas
 * separadas.
 *
 * `PermissionService::PAGE_KNOWLEDGE_VIDEOS` no servidor -- e lá há teste
 * afirmando esta string literal, porque os dois lados precisam concordar no
 * texto: um nome diferente nega em silêncio, sem erro nenhum.
 */
export const PAGINA_DE_VIDEOS = '/ia-base-conhecimento/videos';
